// 超出自定义字字加...
export const Subtle = (data,num)=> {
    let str = ''
    if (!data) return ''
    if (num == 1) {
        switch(data.length) {
              case 1 :
              case 2 :  str=data.substr(0,1)+'*'
              break
              case 3 :  str=data.substr(0,1)+'*'+data.substr(2,3)
              break
              case 4 :  str=data.substr(0,2)+'*'+data.substr(3,4)
              break
              case 5 :  str=data.substr(0,2)+'*'+data.substr(3,5)
              break
              default: str=data.substr(0,2)+'*'+data.substr(data.length-2,data.length)
              break
        }
        return str
    }else if( num==2){
        str = str=data.substr(0,6)+'*'+data.substr(data.length-3,data.length)
    }
}


// WEBPACK FOOTER //
// ./src/filters/index.js